import ProductTemplate from "../../Biscuits-Template/Template";
import BisImg from "../../../assets/products/round creams/round strawberry biscuit.png";
import BiscuitImg from "../../../assets/products/round creams/Round-Starwberry.png";
import { Helmet } from "react-helmet-async";

const BiscuitData = [
  {
    grams: 13,
  },
  {
    grams: 18,
  },
  {
    grams: 20,
  },
  {
    grams: 30,
  },
  {
    grams: 40,
  },
  {
    grams: 50,
  },
  {
    grams: 70,
  },
  {
    grams: 90,
  },
];

export default function StrawberryRoundProduct() {
  return (
    <>
      <Helmet>
        <title>
          Round Strawberry Cream Biscuit – BearBitz | Premium Biscuits & Cookies
        </title>
        <meta
          name="description"
          content="Explore BearBitz Round Strawberry Cream Biscuits — sweet strawberry-flavored sandwich biscuits with creamy filling. View pack sizes, cartons, and specs."
        />
        <meta
          name="keywords"
          content="Round Strawberry Cream Biscuit, BearBitz Strawberry Cream Biscuit"
        />
        <link
          rel="canonical"
          href="https://www.bearbitz.in/round-cream-biscuit/round-strawberry"
        />
        <meta
          property="og:title"
          content="Round Strawberry Cream Biscuit – BearBitz"
        />
        <meta
          property="og:description"
          content="Cream-filled strawberry sandwich biscuit in round shape with export-ready packaging."
        />
      </Helmet>

      <ProductTemplate
        productTitle="STRAWBERRY"
        productImage={BisImg}
        description="Sweet Layers of Joy.Crunchy biscuits filled with rich cream—classic favorites in every shape and flavor. A global snack sensation that delights with every bite."
        tableData={BiscuitData}
        BiscuitLogo={BiscuitImg}
        textColor="#FF009F"
        sectionBgColor="#FFDBF4"
        productBgcolor="#FFADE6"
        tableheadBgcolor="#FF009F"
        tableBgcolor="#FFFAFD"
        footerBgcolor="#FF009F"
      />
    </>
  );
}
